angular.module('bmsApp.settings').controller('WorksheetPreferencesCtrl', function ($scope,
																				   $timeout,
																				   notify,
																				   MMWorksheetSvc) {

	var form = {
		preferences: {},
		options: {
			fontSize: [
				{
					value: 'small',
					label: 'Small'
				},
				{
					value: 'medium',
					label: 'Medium'
				},
				{
					value: 'large',
					label: 'Large'
				}
			]
		},
		validator: {
			config: {
				submitHandler: function () {
					$timeout(function () {
						$scope.$apply(function () {
							form.processing = true;
							MMWorksheetSvc.setPreferences(form.preferences)
								.then(function (response) {
									form.preferences = response.data.mm_worksheet_preferences;
									notify({
										message: 'Worksheet preferences saved'
									});
								}, function (errors) {
									self.errors = errors;
								})
								.finally(function () {
									form.processing = false;
								});
						});
					});
				},
				errorPlacement: function (error) {
					error.appendTo('#customer-errors');
				},
				errorContainer: '#customer-errors'
			}
		},
		processing: false
	};

	var methods = {
		init: function () {
			MMWorksheetSvc.getPreferences()
				.then(function (response) {
					angular.extend(form.preferences, response.data.mm_worksheet_preferences);
				})
				.finally(function () {
					self.loading = false;
				})
			;
		}
	};

	var self = {
		form: form,
		methods: methods,
		loading: true
	};

	$scope.WorksheetPreferencesCtrl = self;

});
